/* eslint-disable */
import ProductHelpersMixin from "../../mixins/ProductHelpersMixin"
import CartHelpersMixin from "../../mixins/CartHelpersMixin"
import Errors from "../../Errors"
import store from "../../store"

export default {
  mixins: [CartHelpersMixin, ProductHelpersMixin],
  props: [
    "isAuth",
    "customerEmail",
    "customerPhone",
    "gateways",
    "shippingAddressId",
    "billingAddressId",
    "sameAddress",
    "addresses",
    "countries",
    "rewardSettings",
    "cards",
    "preOrderDisclaimerMsg",
    "cartHasPreOrderItem"
  ],
  data() {
    return {
      showPreOrderDisclaimerModal: false,
      showConfirmModal: false,
      showPurchaseLimitModal: false,
      customer_phone_iti: null,
      dailyPurchaseErrorProductIDs: [],
      dailyPurchaseErrorMsg: "",
      showPaymentModel: false,
      iti: null,
      billingIti: null,
      addressFormType: "shipping",
      form: {
        customer_email: this.customerEmail,
        customer_phone: this.customerPhone,
        customer_phone_code: null,
        billing: {},
        shipping: {},
        billingAddressId: null,
        shippingAddressId: null,
        newBillingAddress: false,
        newShippingAddress: false,
        ship_to_a_different_address: !this.sameAddress,
        shipToSameAddress: this.sameAddress,
        credit_card_number: null,
        expiration_month: null,
        expiration_year: null,
        credit_card_firstname: null,
        credit_card_lastname: null,
        terms_and_conditions: false,
        ccv: null,
        edit_address: false,
        selectedAddress: null,
        selectedAddressIndex: "",
        edit_billing_address: false,
        selectedBillingAddress: null,
        selectedBillingAddressIndex: "",
        card_id: null,
        payment_method: null,
        payment_token: null,
        customer_notes: null,
        save_card: false,
        new_card: false
      },
      states: {
        billing: {},
        shipping: {}
      },
      placingOrder: false,
      errors: new Errors(),
      billingErrors: new Errors(),
      stripe: null,
      stripeCardElement: null,
      stripeError: null,
      authorizeNetToken: null,
      newCard: false,
      zipCodeError: false,
      checkTaxes: false,
      shippingMethods: [],
      paymentMethods: [],
      savingAddress: false,
      debounceTimers: {}
    }
  },
  mounted() {
    if (this.cartHasPreOrderItem) this.showPreOrderDisclaimerModal = true

    this.form.card_id = this.cards.length > 0 ? this.cards[0].id : null

    if (store.state.cart.shipping_address_id)
      this.form.shippingAddressId = store.state.cart.shipping_address_id

    if (this.addresses.length == 1 || (this.shippingAddressId == 0 && this.addresses.length > 1))
      this.editAddress(0, this.addresses[0])

    setTimeout(() => {
      const element = document.querySelector(".customer_phone_code")
      this.customer_phone_iti = window.intlTelInput(element, {
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
      })
      this.getPaymentMethods()
    }, 1000)

    if (this.cards.length == 0) {
      this.newCard = true
      this.form.new_card = true
    }

    if (!this.hasAddress) {
      setTimeout(() => {
        const element = document.querySelector(".add-shipping-phone")
        this.iti = window.intlTelInput(element, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        })
        const billingElement = document.querySelector(".add-billing-phone")
        this.billingIti = window.intlTelInput(billingElement, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        })
      }, 1000)
    }
  },
  computed: {
    hasAddress() {
      return Object.keys(this.addresses).length !== 0
    },
    firstCountry() {
      return Object.keys(this.countries)[0]
    },
    hasBillingStates() {
      return Object.keys(this.states.billing).length !== 0
    },
    hasShippingStates() {
      return Object.keys(this.states.shipping).length !== 0
    },
    hasNoPaymentMethod() {
      return Object.keys(this.gateways).length === 0
    },
    firstPaymentMethod() {
      return false
      return Object.keys(this.gateways)[0]
    },
    shouldShowPaymentInstructions() {
      return ["bank_transfer", "check_payment"].includes(
        this.form.payment_method
      )
    },
    paymentInstructions() {
      if (this.shouldShowPaymentInstructions) {
        return this.gateways[this.form.payment_method].instructions
      }
    }
  },
  watch: {
    "form.shipping": {
      deep: true,
      handler(newVal) {
        if (newVal != undefined && newVal != null) {
          if (this.form.newShippingAddress) {
            this.handleNewAddressFrom(newVal, "shipping")
          }
        }
      }
    },
    "form.billing": {
      deep: true,
      handler(newVal) {
        if (newVal != undefined && newVal != null) {
          if (this.form.newBillingAddress) {
            this.handleNewAddressFrom(newVal, "billing")
          }
        }
      }
    },
    "form.selectedAddress.id": function(newVal, oldVal) {
      this.debounce(() => this.getShippingMethods(), 1000, 'shippingMethods')
      this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
      this.debounce(() => this.addTaxes(), 1000, 'taxes')
    },
    "form.selectedAddress.name": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.customer_id": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.first_name": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.last_name": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    // Repeat for each key you want to watch
    "form.selectedAddress.address_1": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.address_2": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.city": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.state": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
      this.debounce(() => this.addTaxes(), 1000, 'taxes')
    },
    "form.selectedAddress.zip": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
      this.changeShippingZip(newVal)
      this.debounce(() => this.addTaxes(), 1000, 'taxes')
    },
    "form.selectedAddress.country": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
      this.debounce(() => this.addTaxes(), 1000, 'taxes')
    },
    "form.selectedAddress.email": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.company": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.tax_no": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.phone_code": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    "form.selectedAddress.phone": function(newVal, oldVal) {
      this.saveCustomerShippingAddress(newVal, oldVal)
    },
    // 'form.selectedBillingAddress.id': function(newVal, oldVal) {
    //   this.saveCustomerBillingAddress(newVal, oldVal)
    // },
    "form.selectedBillingAddress.name": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.customer_id": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.first_name": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.last_name": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.address_1": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.address_2": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.city": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.country": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.state": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.zip": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.email": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.company": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.tax_no": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.phone_code": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.selectedBillingAddress.phone": function(newVal, oldVal) {
      this.saveCustomerBillingAddress(newVal, oldVal)
    },
    "form.billingAddressId": function(newVal) {
      if (newVal != this.form.edit_billing_address)
        this.form.edit_billing_address = false

      // Avoid calling saveUserAddress twice in quick succession
      if (this.form.billingAddressId !== this.previousBillingAddressId) {
        this.previousBillingAddressId = newVal
        this.saveUserAddress()
      }

      this.mergeSavedAddresses()

      if (this.form.billing)
        this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
      else if (this.form.selectedAddress)
        this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
    },
    "form.shippingAddressId": function(newVal) {
      if (newVal != this.form.edit_address)
        this.form.edit_address = false

      // Avoid calling saveUserAddress twice in quick succession
      if (this.form.shippingAddressId !== this.previousShippingAddressId) {
        this.previousShippingAddressId = newVal
        this.saveUserAddress()
      }

      this.mergeSavedAddresses()

      if (this.form.shipToSameAddress) {
        if (this.form.shipping)
          this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
        else if (this.form.selectedAddress)
          this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
      }
    },
    "form.shipping.zip": function(newZip) {
      if (newZip) {
        this.debounce(() => this.addTaxes(), 1000, 'taxes')
      }
    },
    "form.shipping.state": function(newState) {
      if (newState) {
        this.debounce(() => this.addTaxes(), 1000, 'taxes')
        this.debounce(() => this.getShippingMethods(), 1000, 'shippingMethods')
      }
    },
    "form.shipping.country": function(newCountry) {
      if (newCountry) {
        this.debounce(() => this.getShippingMethods(), 1000, 'shippingMethods')
        this.debounce(() => this.addTaxes(), 1000, 'taxes')
        if (this.form.shipToSameAddress) {
          this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
        }
        this.$set(this.form.selectedAddress, "shipping", newCountry)
      }
    },
    "form.billing.country": function(newCountry) {
      if (newCountry)
        this.getPaymentMethods(newCountry, null)
    },
    "form.shipToSameAddress": function(newValue) {
      this.form.ship_to_a_different_address = !newValue
      if (this.form.newBillingAddress && newValue) {
        this.form.newBillingAddress = false
      }


      if (newValue && this.form.shippingAddressId) {
        this.form.billing =
          this.addresses[this.form.shippingAddressId]
      } else {
        const billingElement = document.querySelector(".add-billing-phone")
        this.billingIti = window.intlTelInput(billingElement, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        })
        this.form.billing = {}
      }

      this.debounce(() => this.addTaxes(), 1000, 'taxes')
    },
    "form.terms_and_conditions": function() {
      this.errors.clear("terms_and_conditions")
    }
  },
  created() {
    if (this.billingAddressId) {
      this.form.billingAddressId = this.billingAddressId
      if (!this.sameAddress) {
        let address = element => element.id === this.billingAddressId
        this.editBillingAddress(this.addresses.findIndex(address), this.addresses.find(address))
      }
    }

    if (this.shippingAddressId) {
      this.form.shippingAddressId = this.shippingAddressId
      let address = element => element.id === this.shippingAddressId
      this.editAddress(this.addresses.findIndex(address), this.addresses.find(address))
    }

    if (!this.hasAddress) {
      this.form.newBillingAddress = true
      this.form.newShippingAddress = true
    }

    this.$nextTick(() => {
      this.changePaymentMethod(this.firstPaymentMethod)
      this.$set(this.form, "shipping_method", store.state.cart.shippingMethod)
    })
  },
  methods: {
    handleNewAddressFrom(address, type) {
      const {
        id,
        first_name,
        last_name,
        address_1,
        address_2,
        city,
        zip,
        country,
        state,
        phone,
        email,
        company,
        tax_no
      } = address
      if (this.form.newShippingAddress || this.form.newBillingAddress) {
        if (first_name && last_name && address_1 && city && zip && country && state && phone && email) {
          if (type === "shipping") {
            if (this.iti) {
              this.form.shipping["phone_code"] = this.iti.getSelectedCountryData().iso2
              this.$set(this.form.shipping, "phone_code", this.iti.getSelectedCountryData().iso2)
            }
          }
          if (type === "billing") {
            if (this.billingIti) {
              if (this.form.ship_to_a_different_address) {
                this.form.billing["phone_code"] = this.billingIti.getSelectedCountryData().iso2
                this.$set(this.form.billing, "phone_code", this.billingIti.getSelectedCountryData().iso2)
              }
            } else {
              if (this.iti) {
                this.form.billing["phone_code"] = this.iti.getSelectedCountryData().iso2
                this.$set(this.form.billing, "phone_code", this.iti.getSelectedCountryData().iso2)
              }
            }
          }
          if ((type == "shipping" && this.form.shipping && this.form.shipping.id) || (type == "billing" && this.form.billing && this.form.billing.id)) {
            this.savingAddress = true
            let updateRoute = this.isAuth != 0 ?
              route("account.addresses.update", { id: type === "shipping" ? this.form.shipping.id : this.form.billing.id }) :
              route("account.addresses.update_guest")
            if (this.isAuth == 0 && type === "shipping")
              this.form.shipping.type = type
            if (this.isAuth == 0 && type === "billing")
              this.form.billing.type = type
            $.ajax({
              method: "PUT",
              url: updateRoute,
              data: type === "shipping" ? this.form.shipping : this.form.billing
            }).then((response) => {
              if (type == "shipping")
                this.errors.reset()
              else if (type == "billing")
                this.billingErrors.reset()
            }).catch((xhr) => {
              if (xhr.status === 422) {
                this.transformErrors(xhr.responseJSON.errors, type)
              }
            }).always(() => {
              this.savingAddress = false
            })
          } else {

            this.savingAddress = true
            if (type == "shipping")
              this.form.shipping.type = "shipping"
            if (type == "billing")
              this.form.billing.type = "billing"
            $.ajax({
              method: "POST",
              url: route("account.addresses.store"),
              data: type === "shipping" ? this.form.shipping : this.form.billing
            }).then((response) => {
              if (type === "shipping") {
                this.form.shippingAddressId = response.address.id
                this.form.shipping.id = response.address.id
                this.errors.reset()
              }
              if (type === "billing") {
                this.form.billingAddressId = response.address.id
                this.form.billing.id = response.address.id
                this.billingErrors.reset()
              }
              this.saveUserAddress()
              this.$successNotify(response.message)
            }).catch((xhr) => {
              if (xhr.status === 422) {
                this.transformErrors(xhr.responseJSON.errors, type)
              }
            }).always(() => {
              this.savingAddress = false
            })
          }
        }
      }
    },
    closePreOrderDisclaimerProducts() {
      this.$bvModal.hide("confirm-pre-order-disclaimer-products-modal")
      this.placingOrder = false
    },
    redirectToCartPage(productIds) {
      this.$bvModal.hide("confirm-purchase-limit-modal")
      this.placingOrder = false

      // Constructing the URL with multiple productIds parameters
      const productIdParams = productIds.map(id => `purchaseLimitProductIDs[]=${id}`).join("&")

      // Redirecting to the cart page with custom parameters
      window.location.href = `/cart?${productIdParams}`
    },
    confirmed() {
      this.$bvModal.hide("confirm-checkout-modal")
      let form = _.cloneDeep(this.form)
      this.placingOrder = true

      // Send full expiration year in payload
      const currentYear = String(new Date().getFullYear())
      const currentCentury = currentYear.substring(0, 2)
      form.expiration_year = currentCentury + form.expiration_year

      // Remove spaces from CC formatted number
      form.credit_card_number = form.credit_card_number?.replace(" ", "")
      form.inCheckout = true

      $.ajax({
        method: "POST",
        headers: {
          'Accept': 'application/json' // Add this line to accept JSON
        },
        url: route("checkout.create"),
        data: {
          ...form,
          ship_to_a_different_address:
            +form.ship_to_a_different_address
        }
      })
        .then((response) => {
          if (typeof response === "string") {
            response = JSON.parse(response)
          }

          if (response.status == false) {
            this.$errorNotify(response.message)
            this.placingOrder = false

          } else {
            if (response.data?.redirect_url)
              window.location.href = response.data.redirect_url
            else
              this.placingOrder = false
          }
        })
        .catch((error) => {
          if (error?.status === 302) {
            window.location.href = route("login");
          }

          if (error?.status === 406) {
            // This mean the purchase limit validation returned an error.
            this.dailyPurchaseErrorProductIDs = error.responseJSON.productIds
            this.dailyPurchaseErrorMsg = error.responseJSON.message
            this.$bvModal.show("confirm-purchase-limit-modal")
          }

          if (error?.status === 422) {
            this.errors.record(error.responseJSON.errors)
          } else if (error?.status !== 406) {
            this.$errorNotify(error?.responseJSON?.message || error?.message || "Checkout failed.")
          }

          this.placingOrder = false
        })
    },
    formatCreditCardNumber: function() {
      // This method formats the credit card number as the user types.
      // Here, we'll format the number in groups of four digits separated by space.

      let creditCardNumber = this.form.credit_card_number.replace(/\D/g, "")
      let formattedNumber = ""
      for (let i = 0; i < creditCardNumber.length; i += 4) {
        formattedNumber += creditCardNumber.slice(i, i + 4) + " "
      }
      this.form.credit_card_number = formattedNumber.slice(0, -1) // Remove the trailing hyphen
    },
    editAddress(index, address) {
      this.form.newShippingAddress = false
      this.form.newBillingAddress = false
      this.form.shipping = {}
      this.form.edit_address = false
      this.form.selectedAddress = address
      this.form.shippingAddressId = address.id
      this.addressFormType = ""
      this.form.selectedAddressIndex = index
      this.fetchStates(this.form.selectedAddress.country, (states) => {
        this.$set(this.states, "shipping", states)
      })
      setTimeout(() => {
        this.form.edit_address = address.id
        this.addressFormType = "shipping"

        this.$nextTick(() => {
          const element = document.querySelector(".edit-shipping-phone")
          this.iti = window.intlTelInput(element, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
          })
          if (this.form.selectedAddress.phone_code) {
            this.iti.setCountry(this.form.selectedAddress.phone_code)
          }
        })
      }, 1000)
    },
    editBillingAddress(index, address) {
      this.addressFormType = ""
      this.form.billing = {}
      this.form.edit_billing_address = false
      this.form.selectedBillingAddress = address
      this.form.billingAddressId = address.id
      this.form.selectedBillingAddressIndex = index
      this.fetchStates(this.form.selectedBillingAddress.country, (states) => {
        this.$set(this.states, "billing", states)
      })
      setTimeout(() => {
        this.form.edit_billing_address = address.id
        this.addressFormType = "billing"
        this.$nextTick(() => {
          const element = document.querySelector(".edit-billing-phone")
          this.billingIti = window.intlTelInput(element, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
          })
          if (this.form.selectedAddress.phone_code) {
            this.billingIti.setCountry(this.form.selectedAddress.phone_code)
          }
        })
      }, 1000)
    },
    saveAddress(type = "shipping") {

      if (this.iti) {
        if (type == "shipping")
          this.form.selectedAddress.phone_code = this.iti.getSelectedCountryData().iso2
        else
          this.form.selectedBillingAddress.phone_code = this.iti.getSelectedCountryData().iso2
      }
      if (type == "shipping")
        this.shippingAddressId = this.form.selectedAddress.id
      else if (type == "billing")
        this.billingAddressId = this.form.selectedBillingAddress.id
      const {
        id,
        first_name,
        last_name,
        address_1,
        address_2,
        city,
        zip,
        country,
        state,
        phone,
        email,
        company,
        tax_no
      } = type === "shipping" ? this.form.selectedAddress : this.form.selectedBillingAddress
      let updateRoute = this.isAuth != 0 ?
        route("account.addresses.update", { id: type == "shipping" ? this.form.selectedAddress.id : this.form.selectedBillingAddress.id }) :
        route("account.addresses.update_guest")
      if (this.isAuth == 0 && type === "shipping")
        this.form.selectedAddress.type = type
      if (this.isAuth == 0 && type === "billing")
        this.form.selectedBillingAddress.type = type
      this.savingAddress = true
      if (first_name && last_name && address_1 && city && zip && country && state && phone && email) {
        $.ajax({
          method: "PUT",
          url: updateRoute,
          data: type == "shipping" ? this.form.selectedAddress : this.form.selectedBillingAddress
        }).then((response) => {
          if (type == "shipping") {
            // this.form.edit_address = false;
            this.addresses[this.form.selectedAddressIndex] = this.form.selectedAddress
            this.errors.reset()
          } else {
            // this.form.edit_billing_address = false;
            this.addresses[this.form.selectedBillingAddressIndex] = this.form.selectedBillingAddress
            this.billingErrors.reset()
          }
          // this.editing = false;
        }).catch((xhr) => {
          if (xhr.status === 422) {
            this.transformErrors(xhr.responseJSON.errors, type)
          }
        }).always(() => {
          this.savingAddress = false
        })
      } else {
        this.savingAddress = false
      }
    },
    addNewBillingAddress() {
      this.addressFormType = "billing"
      this.form.edit_billing_address = false
      this.billingErrors.reset()

      this.form.billing = {}
      this.form.newBillingAddress = !this.form.newBillingAddress
      setTimeout(() => {
        const element = document.querySelector(".add-billing-phone")
        this.billingIti = window.intlTelInput(element, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        })
      }, 1000)
      if (!this.form.newBillingAddress) {
        this.mergeSavedAddresses()
      }
    },
    addNewShippingAddress() {
      this.addressFormType = "shipping"
      this.form.edit_address = false
      this.errors.reset()

      this.form.shipping = {}
      this.form.newShippingAddress = !this.form.newShippingAddress
      setTimeout(() => {
        const element = document.querySelector(".add-shipping-phone")
        this.iti = window.intlTelInput(element, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
        })
      }, 1000)
      if (!this.form.newShippingAddress) {
        this.mergeSavedAddresses()
      }
    },
    mergeSavedAddresses() {
      this.errors.reset()

      if (!this.form.newShippingAddress && this.form.shippingAddressId) {
        this.form.shipping = this.addresses[this.form.shippingAddressId]
      }

      if (
        this.form.ship_to_a_different_address &&
        !this.form.newBillingAddress &&
        this.form.billingAddressId
      ) {
        this.form.billing =
          this.addresses[this.form.billingAddressId]
      }
    },
    changeBillingCity(city) {
      if (this.form.billing)
        this.$set(this.form.billing, "city", city)
      if (this.form.selectedBillingAddress)
        this.$set(this.form.selectedBillingAddress, "city", city)
    },
    changeShippingCity(city) {
      if (this.form.shipping)
        this.$set(this.form.shipping, "city", city)
      if (this.form.selectedAddress)
        this.$set(this.form.selectedAddress, "city", city)
    },
    changeBillingZip(zip) {
      if (this.form.billing)
        this.$set(this.form.billing, "zip", zip)
      if (this.form.selectedBillingAddress)
        this.$set(this.form.selectedBillingAddress, "zip", zip)
    },
    changeShippingZip(zip) {
      if (this.form.shipping)
        this.$set(this.form.shipping, "zip", zip)
      if (this.form.selectedBillingAddress)
        this.$set(this.form.selectedBillingAddress, "zip", zip)
    },
    changeCardId(cardId) {
      this.$set(this.form.card_id, "card_id", cardId)
    },
    changeBillingCountry(country) {
      if (this.form.billing)
        this.$set(this.form.billing, "country", country)
      if (this.form.selectedAddress)
        this.$set(this.form.selectedAddress, "country", country)

      this.form.billing.state = ""

      if (country === "") {
        this.states.billing = {}
        return
      }

      this.fetchStates(country, (states) => {
        this.$set(this.states, "billing", states)
        this.$set(this.form.billing, "state", "")
      })
    },
    changeShippingCountry(country) {
      if (this.form.shipping)
        this.$set(this.form.shipping, "country", country)
      if (this.form.selectedAddress)
        this.$set(this.form.selectedAddress, "country", country)

      if (this.form.shipping && this.form.shipping.state) this.form.shipping.state = ""

      if (country === "") {
        this.states.shipping = {}
        return
      }

      this.fetchStates(country, (states) => {
        this.$set(this.states, "shipping", states)
        // this.$set(this.form.shipping, "state", "");
      })
    },
    fetchStates(country, callback) {
      $.ajax({
        method: "GET",
        url: route("countries.states.index", { code: country })
      }).then(callback)
    },
    changeBillingState(state) {
      if (this.form.billing)
        this.$set(this.form.billing, "state", state)
      if (this.form.selectedBillingAddress)
        this.$set(this.form.selectedBillingAddress, "state", state)
    },
    changeShippingState(state) {
      if (this.form.shipping)
        this.$set(this.form.shipping, "state", state)
      if (this.form.selectedAddress)
        this.$set(this.form.selectedAddress, "state", state)
    },
    changePaymentMethod(paymentMethod) {
      if (paymentMethod == false) {
        if (this.cart.paymentMethod)
          paymentMethod = this.cart.paymentMethod
      }
      this.$set(this.form, "payment_method", paymentMethod)
    },
    changeShippingMethod(shippingMethodName) {
      this.$set(this.form, "shipping_method", shippingMethodName)
    },
    saveUserAddress() {
      $.ajax({
        method: "POST",
        url: route("cart.taxes.saveAddress"),
        contentType: "application/json",
        data: JSON.stringify(this.form)
      })
        .then((cart) => {
        })
        .catch((xhr) => {
        })
        .always(() => {
        })
    },
    calculateTaxes(form) {
      this.loadingOrderSummary = true
      $.ajax({
        method: "POST",
        url: route("cart.taxes.store"),
        contentType: "application/json",
        data: JSON.stringify(form)
      })
        .then((cart) => {
          store.state.cart = cart
          if (cart.zipCodeError) {
            this.$errorNotify(cart.zipCodeError)
          }

          this.loadingOrderSummary = false
        })
        .catch((xhr) => {
          this.$errorNotify(xhr.responseJSON.message)
          this.loadingOrderSummary = false
        })
        .always(() => {
          this.loadingOrderSummary = false
        })
    },
    addTaxes() {
      if (this.checkTaxes) {
        return // If the function is already executing, do nothing
      }

      this.checkTaxes = true
      // Call your function logic here
      if (
        (this.form.newShippingAddress && this.form.shipping && this.form.shipping.country && this.form.shipping.state && this.form.shipping.zip) ||
        (!this.form.newShippingAddress && this.form.selectedAddress && this.form.selectedAddress.country && this.form.selectedAddress.state && this.form.selectedAddress.zip)
      ) {
        this.calculateTaxes(this.form)
      }

      setTimeout(() => {
        this.checkTaxes = false
      }, 1000) // Reset the flag after 1 second
    },
    placeOrder() {
      if (this.customer_phone_iti) {
        this.form.customer_phone_code = this.customer_phone_iti.getSelectedCountryData().iso2
      }
      if (this.iti) {
        if (this.form.shipping) {
          this.form.shipping.phone_code = this.iti.getSelectedCountryData().iso2
          this.$set(this.form.shipping, "phone_code", this.iti.getSelectedCountryData().iso2)
        }
        if (this.form.billing) {
          if (this.form.ship_to_a_different_address) {
            if (this.billingIti) {
              this.form.billing.phone_code = this.billingIti.getSelectedCountryData().iso2
              this.$set(this.form.billing, "phone_code", this.billingIti.getSelectedCountryData().iso2)
            }
          } else {
            this.form.billing.phone_code = this.iti.getSelectedCountryData().iso2
            this.$set(this.form.billing, "phone_code", this.iti.getSelectedCountryData().iso2)
          }
        }
      }
      let form = _.cloneDeep(this.form)

      if (!form.terms_and_conditions || this.placingOrder) {
        return
      }

      if (!(this.cart.paymentMethodName && (this.cart.paymentMethodName === "google"
        || this.cart.paymentMethodName === "apple")))
        this.$bvModal.show("confirm-checkout-modal")
    },
    confirmOrder(orderId, paymentMethod, transactionId = null, params = {}) {
      $.ajax({
        method: "GET",
        url: route("checkout.complete.store", {
          orderId,
          paymentMethod,
          transactionId,
          ...params
        })
      })
        .then(() => {
          window.location.href = route("checkout.complete.show")
        })
        .catch((xhr) => {
          this.placingOrder = false
          this.loadingOrderSummary = false
          this.deleteOrder(orderId)
          this.$errorNotify(xhr.responseJSON.message)
        })
    },
    deleteOrder(orderId) {
      if (!orderId) {
        return
      }

      $.ajax({
        method: "GET",
        url: route("checkout.payment_canceled.store", { orderId })
      })
    },
    getRewards() {
      if (!store.state.cart.earn_reward)
        return 0
      let rewarded = this.rewardSettings.rewards_multiplier * (store.state.cart.nonDailyDealSubTotal.inCurrentCurrency.formatted - store.state.cart.discount)
      if (rewarded < 0)
        rewarded = 0
      return parseInt(rewarded)
    },
    chooseNewCard() {
      this.newCard = true
      this.form.new_card = true
    },
    chooseCurrentCard() {
      this.newCard = false
      this.form.new_card = false
    },
    notZeroTotal() {
      return store.state.cart.total.inCurrentCurrency.formatted > 0
    },
    // check to hide the card input from the form, due to the payment method requirements
    requireCard() {
      const currentPaymentMethod = this.paymentMethods.find(obj => obj.id === this.cart.paymentMethod)
      if (currentPaymentMethod) {
        return currentPaymentMethod.require_card
      }
      // default value, if payment method did not selected yet
      return true
    },
    getShippingMethods() {
      let country = null
      let state = null
      if (this.form.shipping) {
        country = this.form.shipping.country
        state = this.form.shipping.state
      }
      if (this.form.selectedAddress) {
        country = this.form.selectedAddress.country
        state = this.form.selectedAddress.state
      }

      $.ajax({
        method: "GET",
        url: route("shipping.shipping_methods.index", {
          country: country,
          state: state
        })
      }).then((res) => {
        let data = JSON.parse(res)
        this.shippingMethods = data.data
      })
    },
    getPaymentMethods() {
      let country = null
      if (this.form.billing) {
        country = this.form.billing.country
      }
      if (this.form.selectedAddress) {
        country = this.form.selectedAddress.country
      }

      $.ajax({
        method: "GET",
        url: route("payment.payment_methods.index", {
          country: country
        })
      }).then((res) => {
        let data = JSON.parse(res)
        this.paymentMethods = data.data
      })
    },
    debounce(callback, delay, key = 'default') {
      // Create separate timers for different operations
      if (this.debounceTimers[key]) {
        clearTimeout(this.debounceTimers[key])
      }
      this.debounceTimers[key] = setTimeout(callback, delay)
    },
    transformErrors(errors, type) {
      let transformedErrors = {}

      for (let key in errors) {
        // Prepend 'shipping.' if it's a shipping-related field and doesn't already have it
        let transformedKey = key.startsWith(type + ".") ? key : `${type}.${key}`
        transformedErrors[transformedKey] = errors[key]
      }

      if (type == "shipping")
        this.errors.record(transformedErrors)
      else
        this.billingErrors.record(transformedErrors)
    },
    saveCustomerShippingAddress(newVal, oldVal) {
      this.shippingAddressId = this.form.selectedAddress.id
      if (this.form.edit_address) {
        this.saveAddress("shipping")
        this.debounce(() => this.getShippingMethods(), 1000, 'shippingMethods')
      }
    },
    saveCustomerBillingAddress(newVal, oldVal) {
      this.billingAddressId = this.form.selectedBillingAddress.id
      if (this.form.edit_billing_address)
        this.saveAddress("billing")
      this.debounce(() => this.getPaymentMethods(), 1000, 'paymentMethods')
    }
  }
}
